import { Card } from '@/components/ui/card';
import { MapPin, Calendar, Clock, Users } from 'lucide-react';

export function TournamentCardSkeleton() {
  return (
    <Card className="overflow-hidden">
      <div className="flex">
        {/* Left side - Image skeleton */}
        <div className="w-1/5 max-w-[120px]">
          <div
            className="h-full w-full animate-pulse bg-gray-200"
            style={{ minHeight: '120px' }}
          />
        </div>

        {/* Right side - Content skeleton */}
        <div className="flex-1 p-4">
          {/* Title skeleton */}
          <div className="h-7 w-3/4 animate-pulse rounded bg-gray-200" />

          {/* Club location skeleton */}
          <div className="mt-2 flex items-start">
            <MapPin size={16} className="mr-1 mt-0.5 shrink-0 text-gray-300" />
            <div className="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
          </div>

          {/* Grid layout for details */}
          <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
            {/* Tournament dates skeleton */}
            <div className="flex items-start gap-2">
              <Calendar size={16} className="mt-0.5 shrink-0 text-gray-300" />
              <div className="w-full">
                <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                <div className="mt-1 h-3 w-40 animate-pulse rounded bg-gray-200" />
                <div className="mt-1 h-3 w-36 animate-pulse rounded bg-gray-200" />
              </div>
            </div>

            {/* Registration deadline skeleton */}
            <div className="flex items-start gap-2">
              <Clock size={16} className="mt-0.5 shrink-0 text-gray-300" />
              <div className="w-full">
                <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                <div className="mt-1 h-3 w-40 animate-pulse rounded bg-gray-200" />
                <div className="mt-1 h-3 w-36 animate-pulse rounded bg-gray-200" />
              </div>
            </div>

            {/* Teams skeleton */}
            <div className="flex items-start gap-2">
              <Users size={16} className="mt-0.5 shrink-0 text-gray-300" />
              <div className="w-full">
                <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
                <div className="mt-1 h-6 w-24 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
